<template>
  <div>
    <div id="myDiagramDiv" style="width:600px; height:300px; background-color: #DAE4E4;"></div>
  </div>
</template>
<script>
import G6 from '@antv/g6'
export default {
  props: {
    activeItem: {
      type: String
    }
  },

  mounted() {
    this.renderG6();
  },
  methods: {
    renderG6(){
      const data = {
        nodes: [
          {
            id: 'create',
            label: '创建实例'
          },{
            id: 'depend',
            label: '建立依赖'
          },{
            id: 'instancedownload',
            label: '实例下载'
          },{
            id: 'setResource',
            label: '分配资源'
          },{
            id: 'deploy',
            label: '配置'
          },{
            id: 'releaseResource',
            label: '释放资源'
          },{
            id: 'delete',
            label: '删除'
          },{
            id: 'install',
            label: '安装'
          },{
            id: 'uninstall',
            label: '卸载'
          }
        ],
        edges: [
          {
            source: 'create',
            target: 'depend'
          },
          {
            source: 'create',
            target: 'instancedownload'
          },
          {
            source: 'create',
            target: 'setResource'
          },
          {
            source: 'setResource',
            target: 'releaseResource'
          },
          {
            source: 'releaseResource',
            target: 'setResource'
          },
          {
            source: 'releaseResource',
            target: 'delete'
          },
          {
            source: 'deploy',
            target: 'install'
          },
          {
            source: 'install',
            target: 'uninstall'
          },
          {
            source: 'uninstall',
            target: 'install'
          },        
          {
            source: 'depend',
            target: 'deploy'
          },     
          {
            source: 'instancedownload',
            target: 'deploy'
          },     
          {
            source: 'setResource',
            target: 'deploy'
          },     
          // {
          //   source: 'uninstall',
          //   target: 'releaseResource'
          // },
          
          
        ]
      }
      const width = document.getElementById('myDiagramDiv').scrollWidth;
      const height = document.getElementById('myDiagramDiv').scrollHeight || 500;
      const graph = new G6.Graph({
        container: 'myDiagramDiv',
        width,
        height,
        fitView: true,
        modes: {
          default: ['drag-canvas', 'drag-node'],
        },
        layout: {
          type: 'dagre',
          rankdir: 'LR',
          align: 'DL',
          nodesepFunc: () => 1,
          ranksepFunc: () => 1,
          ranksep: 60,
          controlPoints: true
        },
        defaultNode: {
          size: [60, 30],
          type: 'rect',
          style: {
            lineWidth: 2,
            stroke: '#5B8FF9',
            fill: '#C6E5FF',
          },
        },
        defaultEdge: {
          type: 'polyline',
          size: 1,
          color: '#409EFF',
          // style: {
          //   endArrow: {
          //     path: 'M 0,0 L 8,4 L 8,-4 Z',
          //     fill: '#409EFF'
          //   },
          // },
          style: {
            radius: 20,
            offset: 45,
            endArrow: true,
            lineWidth: 2,
            stroke: '#409EFF',
          },
        },
      });
      graph.node(node =>{
        let obj = {
          id: node.id,
          label: node.label
        }
        
        // node.id == this.activeItem
        if(this.activeItem.startsWith(node.id)){
          obj.style = {
            fill: '#67C23A',
            stroke: '#67C23A'
          }
        }
        return obj
      })
      graph.data(data);
      graph.render();
    }
  }
};
</script>
<style scoped>
</style>